module.exports = __webpack_public_path__ + "static/media/BG@2x.1472d607.png";